import { render } from "./ArrSvg.vue?vue&type=template&id=2d33670e&scoped=true"
const script = {}

import "./ArrSvg.vue?vue&type=style&index=0&id=2d33670e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d33670e"]])

export default __exports__